export const MIN_COL = '220px'

export function gridColumns(patientCount: number, includeMergedColumn = false) {
  if (includeMergedColumn) {
    return `140px repeat(${patientCount}, minmax(${MIN_COL}, 1fr)) minmax(${MIN_COL}, 1fr)`
  }
  return `140px repeat(${patientCount}, 1fr)`
}
